<template>
  <div class="wrapper">
    <div class="bg-image"></div>
    <div class="logo"></div>
    <div class="login-form">
      <h1>LOGIN</h1>
      <p>Please enter your account information</p>
      <label>Email</label>
      <input 
        v-model="loginEmail"
        type="text"
        @keyup.enter="authenticate"
        spellcheck="false" />
      <label>Password</label>
      <input 
        v-model="loginPassword"
        @keyup.enter="authenticate"
        type="password"
        spellcheck="false" />
      <label class="remember-me">
        <input type="checkbox" :value="false" v-model="rememberMe"/>
        <span>REMEMBER ME</span>
      </label>
      <p
        v-if="loginErrorMsg !== ''" class="error">{{ loginErrorMsg }}</p>
      <button @click="authenticate">Login</button>
    </div>
  </div>
</template>

<script>
import { authenticate } from '@/api/requests';

export default {
  name: 'Login',

  data() {
    return {
      loginErrorMsg: '',
      loginEmail: '',
      loginPassword: '',
      rememberMe: false,
    };
  },

  methods: {
    authenticate() {
      if (this.validLoginAttempt()) {
        const userData = { username: this.loginEmail, password: this.loginPassword };

        authenticate(userData).then(response => {
          this.$store.commit('users/setUserData', response.data);
          this.$router.push('/app/dashboard');
        }).catch(() => {
          // TODO errors
        });
      }
    },

    validLoginAttempt() {
      if (this.loginEmail !== '' && this.loginPassword !== '') {
        return true;
      } else {
        // TODO errors
        // this.$toasted.global.app_error({
        //   message: "Please submit an email and password."
        // });

        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";

.wrapper {
  background-color: $sec0;
  position: absolute;
  width: 100%;
  height: 100%;

  .logo {
    width: 464px;
    height: 120px;
    background-image: url(~@/assets/wotive-logo.png);
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    margin: auto;
    margin-top: 80px;
  }

  .bg-image {
    position: absolute;
    right: 0;
    width: 60%;
    height: 100%;
    background-image: url(~@/assets/landing-page/muscle-map.svg);
    background-repeat: no-repeat;
    background-size: cover;
    z-index: 1;
  }

  .login-form {
    position: absolute;
    max-width: 464px;
    background: #FFF;
    margin: auto;
    margin-top: 70px;
    padding: $spacing-large;
    padding-bottom: $spacing-large*2;
    border-radius: $border-radius;
    border: 1px solid $sec6;
    box-sizing: border-box;
    margin-left: -232px;
    left: 50%;
    z-index: 2;

    h1 {
      margin: 0;
      padding: 0;
      text-align: center;
      color: $sec0;
      font-weight: 500;
      font-size: 36px;
    }

    p {
      margin-top: $spacing-small;
      color: $sec5;
      text-align: center;
      text-transform: uppercase;
      font-weight: bold;
      font-size: 14px;
    }

    label {
      font-size: $font-size-small;
      color: $sec3;
    }

    .remember-me {
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        font-weight: bold;
        color: $sec5;
      }
    }

    input[type=text],
    input[type=password] {
      width: 100%;
      height: 40px;
      box-sizing: border-box;
      border-radius: 0;
      border: 0;
      background: $sec7;
      margin-bottom: $spacing-small;
      padding: 8px;
      color: $sec1;
    }

    input[type=text]:focus,
    input[type=password]:focus {
      outline: none !important;
      border:1px solid $blue;
    }

    input[type=checkbox]:checked {
      color: $blue;
    }

    button {
      margin-top: $spacing-base;
      background-color: $blue;
      color: #fff;
      border: 0;
      height: 40px;
      width: 100%;
      border-radius: $border-radius;
    }
  }
}
</style>
